export const currentStaticsDir = "static-gh";
